"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Strings = void 0;
const checks_1 = require("./checks");
class Strings {
    static replaceAll(source, searchValue, replaceValue) {
        return source.replace(new RegExp(searchValue, "gm"), replaceValue);
    }
    static isString(val) {
        return typeof val === "string" || val instanceof String;
    }
    static dropNonPrintable(val) {
        const fnTag = "Strings#dropNonPrintable()";
        checks_1.Checks.truthy(Strings.isString(val), `${fnTag} Strings.isString(val)`);
        return val.replace(/[^ -~]+/g, "");
    }
}
exports.Strings = Strings;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5ncy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tYWluL3R5cGVzY3JpcHQvc3RyaW5ncy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxxQ0FBa0M7QUFFbEMsTUFBYSxPQUFPO0lBQ1gsTUFBTSxDQUFDLFVBQVUsQ0FDdEIsTUFBYyxFQUNkLFdBQW1CLEVBQ25CLFlBQW9CO1FBRXBCLE9BQU8sTUFBTSxDQUFDLE9BQU8sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxXQUFXLEVBQUUsSUFBSSxDQUFDLEVBQUUsWUFBWSxDQUFDLENBQUM7SUFDckUsQ0FBQztJQUVNLE1BQU0sQ0FBQyxRQUFRLENBQUMsR0FBUTtRQUM3QixPQUFPLE9BQU8sR0FBRyxLQUFLLFFBQVEsSUFBSSxHQUFHLFlBQVksTUFBTSxDQUFDO0lBQzFELENBQUM7SUFFTSxNQUFNLENBQUMsZ0JBQWdCLENBQUMsR0FBVztRQUN4QyxNQUFNLEtBQUssR0FBRyw0QkFBNEIsQ0FBQztRQUMzQyxlQUFNLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxLQUFLLHdCQUF3QixDQUFDLENBQUM7UUFDdkUsT0FBTyxHQUFHLENBQUMsT0FBTyxDQUFDLFVBQVUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNyQyxDQUFDO0NBQ0Y7QUFsQkQsMEJBa0JDIn0=